export default __webpack_public_path__ + "static/media/article08.bde2e132.md";